import React, { Component } from 'react';
import SGame from 'shared/screens/Game';
// eslint-disable-next-line no-unused-vars
import GameInterface from 'shared/api/GameInterface';
import { counterTypes } from 'shared/utils/TimestampManager';
import { fetchGameRooms } from 'shared/state/query/games/utils';
import ActivityIndicator from '../../components/ActivityIndicator/ActivityIndicator';
import Logger from 'shared/lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { ONBOARDING_FLOWS } from 'shared/utils/onboarding';
import CountdownTimer from '../../lib/time/component/CountdownTimer';
import { FTUE_STEPS_KEYS } from 'shared/constants';

const skipAsset = require(asset`images/FTUE/skip_button@3x.png`);
export default class Game extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.netEntExtend = null;
    this.isSneakPeek = React.createRef(false);
  }

  /** @type {GameInterface} */
  game = null;
  gameProvider = null;
  gameRef = React.createRef();
  messageHandlerFuncRef = null;

  componentWillUnmount() {
    if (this.game) {
      window.removeEventListener('message', this.messageHandlerFuncRef);
    }
    window.removeEventListener('resize', this.handleResize);
    this.isSneakPeek.current && fetchGameRooms(true);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  messageHandlerFunc(msg) {
    this.game.messageHandle(msg, this.gameProvider);
  }

  handleResize = () => {
    if (this.netEntExtend) {
      const gameWidth = parseInt(document.getElementById('gameArea').offsetWidth);
      const gameHeight = parseInt(document.getElementById('gameArea').offsetHeight);
      const gameAspectRatio = gameWidth / gameHeight;
      const newHeight = window.innerHeight - 80;
      const newWidth = newHeight * gameAspectRatio;
      this.netEntExtend.resize(newWidth, newHeight);
    }
  };

  dispatcher = message => {
    if (this.netEntExtend) {
      if (message.eventType === 'SET') {
        this.netEntExtend.set(
          message.event,
          message.value,
          () => null,
          () => null
        );
      } else {
        this.netEntExtend.get(
          message.event,
          eventRes => {
            this.game.checkEventData(eventRes, message.event);
          },
          () => null
        );
      }
    } else {
      if (this.gameRef.current) {
        this.gameRef.current.contentWindow.postMessage(message, '*');
      }
    }
  };

  startGame = config => {
    const netEntConfig = { ...config, targetElement: 'gameArea', fullScreen: true };
    const success = netEntExtend => {
      this.netEntExtend = netEntExtend;
      const gameWidth = parseInt(document.getElementById('gameArea').offsetWidth);
      const gameHeight = parseInt(document.getElementById('gameArea').offsetHeight);
      const gameAspectRatio = gameWidth / gameHeight;
      const newHeight = window.innerHeight - 80;
      const newWidth = newHeight * gameAspectRatio;
      netEntExtend.resize(newWidth, newHeight);
    };
    const error = e => {};
    window.netent.launch(netEntConfig, success, error);
  };

  endTimerCallback = () => this.setState({ timerIsFinished: true });

  checkToRemoveListener = () =>
    this.messageHandlerFuncRef && window.removeEventListener('message', this.messageHandlerFuncRef);

  render() {
    return (
      <SGame
        navigation={this.props.navigation}
        deviceInfo={this.props.deviceInfo}
        RFValue={this.props.RFValue}
        dimension={this.props.dimension}
        render={args => {
          const { gameInterface, gameLink, gameProvider, netEntConfig, ftueStep, sneakPeekTimer, skipTutorialGame } =
            args;
          this.isSneakPeek.current = sneakPeekTimer;
          const skipTutorial = () => {
            Logger.sendEvent(EVENT_TYPES.TUTORIAL_SKIPPED, {
              id: ONBOARDING_FLOWS.CHALLENGES_ONBOARDING,
              skipped: 1,
            });
            skipTutorialGame();
          };

          // Short circuit on this.game first to prevent extra checks
          if (
            (this.game === null && gameInterface !== null) ||
            (this.game !== gameInterface && gameProvider !== this.gameProvider)
          ) {
            this.checkToRemoveListener();
            this.game = gameInterface;
            this.gameProvider = gameProvider;
            this.game.dispatcher = this.dispatcher;
            this.messageHandlerFuncRef = this.messageHandlerFunc.bind(this);
            window.addEventListener('message', this.messageHandlerFuncRef);
          }
          if (netEntConfig !== null) {
            this.startGame(netEntConfig);
          }
          return (
            <>
              <div className="GameScreen">
                <ActivityIndicator />
                {gameLink !== null && !netEntConfig && (
                  <iframe ref={this.gameRef} src={gameLink} frameBorder="none" title="gameLink" />
                )}
                {netEntConfig && <div id="gameArea"></div>}
              </div>
              {ftueStep > FTUE_STEPS_KEYS.INITIAL && ftueStep !== FTUE_STEPS_KEYS.CLICKED_ON_SPINNER && (
                <div style={{ zIndex: 100, top: 70 }} class="FtueSkipHolder" onClick={() => skipTutorial()}>
                  <img src={skipAsset} alt="Skip Tutorial" style={{ width: 140, height: 50, objectFit: 'contain' }} />
                </div>
              )}
              {sneakPeekTimer && sneakPeekTimer > 0 && !this.state.timerIsFinished && (
                <div className="sneakPeekTimerHolder">
                  <img src={require(asset`images/SneakPeek/Timer_displayed_screen@3x.png`)} alt="timer" />
                  <CountdownTimer
                    counterType={counterTypes.SNEAK_PEEK}
                    endDate={sneakPeekTimer * 1000}
                    justTimerText={true}
                    endTimerCallback={this.endTimerCallback}
                    style={{ opacity: 0.9, fontWeight: 700 }}
                  />
                </div>
              )}
            </>
          );
        }}
      />
    );
  }
}

Game.defaultProps = {
  deviceInfo: null,
  RFValue: null,
  dimension: null,
};

